import { connect } from 'react-redux';

import Search from './Search';
import { search, setActive } from 'actions/search-actions';
import { getSearchIsActive } from 'store/reducers/search';

const mapStateToProps = (state) => ({
  isActive: getSearchIsActive(state),
});

const mapDispatchToProps = {
  onSetActive: setActive,
  onSearch: search,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
